export type UsageHeat = "ok" | "warn" | "critical" | "over"

export function usageRatio(
  used: number,
  limit: number,
): number | null {
  if (limit < 0) return null
  if (limit === 0) return used > 0 ? 1 : 0
  return used / limit
}

export function usageHeat(ratio: number | null): UsageHeat {
  if (ratio == null) return "ok"
  if (ratio >= 1) return "over"
  if (ratio >= 0.9) return "critical"
  if (ratio >= 0.7) return "warn"
  return "ok"
}

export function formatStorageBytes(n: number): string {
  if (!Number.isFinite(n) || n < 0) return "0 B"
  const u = ["B", "KB", "MB", "GB", "TB"]
  let v = n
  let i = 0
  while (v >= 1024 && i < u.length - 1) {
    v /= 1024
    i += 1
  }
  const d = i === 0 ? 0 : i === 1 ? 0 : 1
  return `${v.toFixed(d)} ${u[i]}`
}

export function formatCount(n: number, singular: string, plural?: string): string {
  const p = plural ?? `${singular}s`
  return `${n.toLocaleString()} ${n === 1 ? singular : p}`
}
